import React, { Component } from 'react';
import PropTypes from 'prop-types';
import VideoHeader from 'components/VideoHeader';
import classNames from 'classnames';
import _ from 'lodash';
import { COLLECTION_HERO_IMAGE, getDynamicImage } from 'helpers/ImageHelper';
import { noop } from 'helpers/GlobalHelper';
import Style from 'app/themes/styleguide/redesign/v2/HomeSlideHeader.module.scss';
import videoHeaderStyleV2 from './VideoHeader.v2.module.scss';
import singleVideoHeaderStyleV2 from './VideoHeaderSingle.v2.module.scss';
import InfoTags from './Components/InfoTags';
import SlideStyle from './HomeSlideHeader.module.scss';

/**
 * HomeSlideHeader Component
 * @param {Object}   panel        - Panel object
 * @returns {Component}           - React Component
    <HomeSlideHeader item={item} />
 */
class HomeSlideHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paused: false,
      isDescriptionOpen: false,
      headerImageState: null,
    };
    this.mainPostition = null;
    this.altPostition = null;

    this.toggleDescription = this.toggleDescription.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { disableSingleVideoHeroRender, videoIsLive } = this.props;
    const { disableSingleVideoHeroRender: prevDisableSingleVideoHeroRender } = prevProps;
    if (
      disableSingleVideoHeroRender !== prevDisableSingleVideoHeroRender &&
      disableSingleVideoHeroRender
    ) {
      this.setState({
        headerImageState: videoIsLive ? 'live video' : 'autoplay video',
      });
    }
  }

  setHeaderImageState = state => {
    this.setState({ headerImageState: state });
  };

  toggleDescription(e) {
    e.stopPropagation();
    e.preventDefault();
    const { isDescriptionOpen } = this.state;
    this.setState({ isDescriptionOpen: !isDescriptionOpen });
  }

  renderHeaderComponent({ render, showHeaderBelowTags }) {
    const { foxAwesomeLayout, heroImage } = this.props;

    if (!render) return null;

    const testTag = showHeaderBelowTags
      ? 'first-collection-header-below-tags'
      : 'first-collection-header-above-tags';

    return (
      <div data-test={testTag}>
        {foxAwesomeLayout && this.renderSingleVideoHero()}
        {heroImage}
      </div>
    );
  }

  renderSingleVideoHero() {
    const {
      breakpoint,
      disableSingleVideoHeroRender,
      disableVideoRender,
      foxAwesomeLayout,
      idx,
      isHeroCarousel,
      item: {
        videoId,
        stillBackgroundImage,
        videoBackgroundImage,
        promoBackgroundImage,
        promoBackgroundVideo,
        watchLink,
        originalVideo,
      },
      onSelection,
      play,
      removeVideoHero,
      setVideoHero,
    } = this.props;
    const disableVideoForPromo = !!promoBackgroundImage;
    const dontRenderVideo = disableVideoRender || disableVideoForPromo;
    if (disableSingleVideoHeroRender) return null;
    const promoTypeIsShowcaseBurntIn = _.get(originalVideo, 'promoType') === 'showcaseBurntIn';
    const videoPlaceHolder = dontRenderVideo
      ? null
      : getDynamicImage({
          breakpoint,
          url: promoBackgroundVideo || videoBackgroundImage,
          context: COLLECTION_HERO_IMAGE,
        });
    return (
      <VideoHeader
        theme={videoHeaderStyleV2}
        foxAwesomeLayout={foxAwesomeLayout}
        id={videoId}
        idx={idx}
        image={getDynamicImage({
          breakpoint,
          url: disableVideoForPromo ? promoBackgroundImage : stillBackgroundImage,
          context: COLLECTION_HERO_IMAGE,
        })}
        isHeroCarousel={isHeroCarousel}
        onMount={setVideoHero}
        onTitleClick={onSelection}
        onUnmount={removeVideoHero}
        play={play}
        setHeaderImageState={this.setHeaderImageState}
        shadowOnPlayButton={false}
        themeSingleVideoHeader={singleVideoHeaderStyleV2}
        video={videoPlaceHolder}
        watchLink={watchLink}
        promoTypeIsShowcaseBurntIn={promoTypeIsShowcaseBurntIn}
      />
    );
  }

  render() {
    const {
      account,
      allowInfoToggle,
      breakpoint,
      callCollectionImpressionEvent,
      collectionInfo,
      foxAwesomeLayout,
      hasSingleSlide,
      idx,
      isLive,
      isHeroCarousel,
      item,
      onPrimaryButtonClick,
      onTitleClick,
      onWatch,
      overlay,
      overridePlayButtonClick,
      overridePlayButtonLink,
      router,
      saveLiveRestart,
      saveLiveVideo,
      setOverlay,
      setSuggestedChannel,
      showLiveButtons,
      smallCollectionHeader,
      title,
      useSeriesLogo,
    } = this.props;
    const { paused, isDescriptionOpen, headerImageState } = this.state;
    const infoTagProps = {
      account,
      allowInfoToggle,
      breakpoint,
      callCollectionImpressionEvent,
      collectionInfo,
      foxAwesomeLayout,
      headerImageState,
      idx,
      isLive,
      isDescriptionOpen,
      item,
      onPrimaryButtonClick,
      onTitleClick,
      onWatch,
      overlay,
      overridePlayButtonClick,
      overridePlayButtonLink,
      router,
      saveLiveRestart,
      saveLiveVideo,
      setOverlay,
      setSuggestedChannel,
      showLiveButtons,
      smallCollectionHeader,
      style: Style,
      useSeriesLogo,
      toggleDescription: this.toggleDescription,
    };
    const { id } = item;
    const slideId = `${id}_${idx}_slide`;
    const containerClasses = classNames([
      foxAwesomeLayout ? Style.fowAwesomeContainer : Style.container,
      paused ? Style.paused : Style.playing,
      SlideStyle.pageMaxWidth,
      hasSingleSlide ? Style.singleSlide : null,
      isHeroCarousel ? [Style.carouselStyle, SlideStyle.carouselMaxWidth] : null,
      SlideStyle.showSlide,
    ]);
    const showHeaderBelowTags = foxAwesomeLayout && smallCollectionHeader;
    return (
      <div className={containerClasses} data-name={title} id={slideId}>
        {this.renderHeaderComponent({ render: !showHeaderBelowTags, showHeaderBelowTags })}
        <InfoTags {...infoTagProps} />
        {this.renderHeaderComponent({ render: showHeaderBelowTags, showHeaderBelowTags })}
      </div>
    );
  }
}

HomeSlideHeader.propTypes = {
  account: PropTypes.shape({}),
  allowInfoToggle: PropTypes.bool,
  breakpoint: PropTypes.string,
  collectionInfo: PropTypes.shape({}),
  coordinates: PropTypes.shape({}),
  disableSingleVideoHeroRender: PropTypes.bool,
  disableVideoRender: PropTypes.bool,
  foxAwesomeLayout: PropTypes.bool,
  hasSingleSlide: PropTypes.bool,
  idx: PropTypes.number,
  isHeroCarousel: PropTypes.bool,
  isLive: PropTypes.bool,
  setCoordinates: PropTypes.func,
  item: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  onPrimaryButtonClick: PropTypes.func,
  onSelection: PropTypes.func,
  onTitleClick: PropTypes.func.isRequired,
  onWatch: PropTypes.func,
  overlay: PropTypes.string,
  overridePlayButtonClick: PropTypes.func,
  overridePlayButtonLink: PropTypes.bool,
  play: PropTypes.bool,
  removeVideoHero: PropTypes.func,
  heroImage: PropTypes.shape({}),
  router: PropTypes.shape({}).isRequired,
  saveLiveRestart: PropTypes.func.isRequired,
  saveLiveVideo: PropTypes.func,
  setOverlay: PropTypes.func,
  setSuggestedChannel: PropTypes.func.isRequired,
  setVideoHero: PropTypes.func,
  showLiveButtons: PropTypes.bool,
  smallCollectionHeader: PropTypes.bool,
  title: PropTypes.string,
  toggleVideoModal: PropTypes.func,
  useSeriesLogo: PropTypes.bool,
  callCollectionImpressionEvent: PropTypes.func,
  videoIsLive: PropTypes.bool.isRequired,
};

HomeSlideHeader.defaultProps = {
  account: null,
  allowInfoToggle: false,
  breakpoint: null,
  callCollectionImpressionEvent: noop,
  collectionInfo: {},
  coordinates: null,
  disableSingleVideoHeroRender: null,
  disableVideoRender: null,
  foxAwesomeLayout: false,
  hasSingleSlide: false,
  heroImage: null,
  idx: null,
  isHeroCarousel: false,
  isLive: false,
  onPrimaryButtonClick: noop,
  onSelection: noop,
  onWatch: noop,
  overlay: null,
  overridePlayButtonClick: () => {},
  overridePlayButtonLink: false,
  play: false,
  removeVideoHero: noop,
  saveLiveVideo: noop,
  setCoordinates: noop,
  setOverlay: noop,
  setVideoHero: noop,
  showLiveButtons: true,
  smallCollectionHeader: false,
  title: '',
  toggleVideoModal: noop,
  useSeriesLogo: false,
};

export default HomeSlideHeader;
